import React from "react";
import styled from "styled-components";
import Splash from "../../shared/Splash";
import Footer from "../../shared/Footer";
import Helmet from "react-helmet";
import img from "../../../assets/banner.jpg";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default function Thanks() {
  return (
    <Wrapper>
      <Helmet
        title="AchieveCE | Thank you!"
        meta={[
          { name: "description", content: "Home Page for AchieveCE" },
          { property: "og:type", content: "website" },
          { property: "og:title", content: "Approved professional learning" },
          { property: "og:url", content: "http://achievece.com" }
        ]}
      />
      <Splash id="thanks" img={img} />
      <Footer />
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/Thanks/Thanks.jsx